import React, { useState, useEffect } from "react";
import Carousel from "react-bootstrap/Carousel";
import client from "../contentfulClient";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import rehypeRaw from "rehype-raw";
import { getConfig } from "../helpers/auth-helper";
import { getSrcPath } from "../helpers/auth-helper";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
let process = {
  env: {}
};
const FAQItem = _ref => {
  let {
    faq,
    index,
    toggleFAQ,
    activeIndex
  } = _ref;
  const isActive = activeIndex === index;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    onClick: () => toggleFAQ(index),
    style: {
      cursor: "pointer",
      fontSize: "16px",
      fontWeight: "600",
      margin: "24px 0px 0px",
      display: "flex",
      justifyContent: "space-between"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      width: "275px"
    }
  }, faq.question), /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("img", {
    style: {
      height: "16px"
    },
    src: isActive ? "https://d3hc1c528irei0.cloudfront.net/ui/VectorUp.png" : "https://d3hc1c528irei0.cloudfront.net/ui/VectorDown.png",
    alt: ""
  }))), isActive && /*#__PURE__*/React.createElement("div", {
    style: {
      marginTop: "8px",
      opacity: "0.8",
      fontSize: "14px",
      fontWeight: "400"
    }
  }, /*#__PURE__*/React.createElement(ReactMarkdown, {
    rehypePlugins: [rehypeRaw],
    remarkPlugins: [remarkGfm]
  }, faq.answer)), /*#__PURE__*/React.createElement("div", {
    style: {
      height: "1px",
      backgroundColor: "white",
      marginTop: "24px"
    }
  }));
};
const FAQList = _ref2 => {
  var _posts$fields, _posts$fields2, _posts$fields3;
  let {
    faqs,
    posts,
    navigate
  } = _ref2;
  const [activeIndex, setActiveIndex] = useState(null);
  const toggleFAQ = index => {
    setActiveIndex(activeIndex === index ? null : index);
  };
  return /*#__PURE__*/React.createElement("div", {
    style: {
      padding: "32px 24px 40px",
      color: "#fff",
      paddingBottom: "117px",
      backgroundColor: "#172323"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: "24px",
      fontWeight: "400",
      marginBottom: "24px"
    }
  }, posts === null || posts === void 0 || (_posts$fields = posts.fields) === null || _posts$fields === void 0 ? void 0 : _posts$fields.faqTitle), faqs.map((faq, index) => /*#__PURE__*/React.createElement(FAQItem, {
    key: index,
    faq: faq,
    index: index,
    toggleFAQ: toggleFAQ,
    activeIndex: activeIndex
  })), /*#__PURE__*/React.createElement("div", {
    style: {
      marginTop: "24px",
      fontSize: "16px",
      fontWeight: "700",
      display: "flex"
    }
  }, posts === null || posts === void 0 || (_posts$fields2 = posts.fields) === null || _posts$fields2 === void 0 ? void 0 : _posts$fields2.pageFooterText, "\xA0\xA0\xA0", /*#__PURE__*/React.createElement("div", {
    onClick: () => window.open("https://www.bengaluruairport.com/travellers/contact-us", "_blank"),
    style: {
      color: "#04ADAA",
      textDecoration: "none"
    }
  }, posts === null || posts === void 0 || (_posts$fields3 = posts.fields) === null || _posts$fields3 === void 0 ? void 0 : _posts$fields3.pageFooterConatctUs)));
};
const Home = _ref3 => {
  var _posts$fields4, _posts$fields5, _posts$fields6, _posts$fields7, _memberData$balances$, _posts$fields8, _posts$fields9, _posts$fields10, _posts$fields11, _posts$fields12, _posts$fields13, _posts$fields14, _posts$fields15, _posts$fields16, _posts$fields17, _posts$fields18, _posts$fields19, _posts$fields20, _posts$fields21, _posts$fields22, _posts$fields23, _posts$fields24, _posts$fields25, _posts$fields26, _posts$fields27, _posts$fields28, _posts$fields29, _posts$fields30, _posts$fields31, _posts$fields32, _posts$fields33, _posts$fields34, _posts$fields35, _posts$fields36, _posts$fields37, _posts$fields38, _posts$fields39, _posts$fields40, _posts$fields41, _posts$fields42, _posts$fields43, _posts$fields44, _posts$fields45, _posts$fields46, _posts$fields47, _posts$fields48, _posts$fields49, _posts$fields50, _posts$fields51, _posts$fields52, _posts$fields53;
  let {
    navigate
  } = _ref3;
  const headerConfig = getConfig();
  const hostSrc = getSrcPath();
  const [memberData, setMemberData] = useState(null);
  const [memberName, setMemberName] = useState("");
  const [tierCodes, setTierData] = useState(null);
  const jwtToken = localStorage.getItem("jwtToken");
  const memberId = localStorage.getItem("memberId");
  const [skeletonLoading, setSkeletonLoading] = useState(true);
  const scrollToTop = () => {
    window.scrollTo(0, 0);
  };
  useEffect(() => {
    scrollToTop();
  }, []);
  useEffect(() => {
    let isMounted = true; // Track if the component is mounted
    setMemberName(localStorage.getItem("memberName"));
    const getMemberData = async () => {
      const url = hostSrc + "/bolapi/v1/members/data/".concat(memberId, "/");
      const headers = headerConfig;
      try {
        const response = await fetch(url, {
          method: "GET",
          headers: headers
        });
        const data = await response.json();
        if (isMounted) {
          // Only update state if component is still mounted
          setMemberData(data.data); // Directly set the data part
          localStorage.setItem("memberData", JSON.stringify(data.data));
          setSkeletonLoading(false);
        }
      } catch (error) {
        console.error("Error:", error);
      }
    };
    const getTierData = async () => {
      const url = hostSrc + "/bolapi/v1/tier-classes/1/tier-level/?page_size=100/";
      const headers = headerConfig;
      try {
        const response = await fetch(url, {
          method: "GET",
          headers: headers
        });
        const data = await response.json();
        if (isMounted) {
          // Only update state if component is still mounted
          setTierData(data);
          localStorage.setItem("tierCodes", JSON.stringify(data));
        }
      } catch (error) {
        console.error("Error:", error);
      }
    };
    getMemberData();
    getTierData();
    return () => {
      isMounted = false; // Cleanup function to prevent state update on unmounted component
    };
  }, [memberId]);
  const [posts, setPosts] = useState([]);
  const [faqs, setFaqs] = useState([]);
  function pageTitleFunc(pageTitle) {
    if (pageTitle != undefined) {
      const pageTitleVar = pageTitle.replace(/\*\*(.*?)\*\*/, "&nbsp;<p>$1</p>&nbsp;");
      return pageTitleVar;
    }
  }
  function cardTextZoomFunc(pageTitle) {
    if (pageTitle != undefined) {
      const pageTitleVar = pageTitle.replace(/\*\*(.*?)\*\*/, '&nbsp;<p style="font-size: 30px; margin-bottom: 6px; font-weight: 700;">$1</p>&nbsp;');
      return pageTitleVar;
    }
  }
  useEffect(() => {
    const fetchPostById = async () => {
      try {
        const entry = await client.getEntry("2IG5ZcMxwXUI4YignS80Sq");

        // Check for linked assets or entries and resolve them
        const resolveLinks = async fields => {
          const resolvedFields = {
            ...fields
          };
          for (const key in fields) {
            const field = fields[key];
            if (Array.isArray(field)) {
              resolvedFields[key] = await Promise.all(field.map(async item => {
                if (item.sys && item.sys.type === "Link") {
                  return await client.getAsset(item.sys.id); // Resolve linked assets
                }
                return item;
              }));
            } else if (field.sys && field.sys.type === "Link") {
              if (field.sys.linkType === "Asset") {
                resolvedFields[key] = await client.getAsset(field.sys.id);
              } else if (field.sys.linkType === "Entry") {
                resolvedFields[key] = await client.getEntry(field.sys.id);
              }
            }
          }
          return resolvedFields;
        };
        const resolvedFields = await resolveLinks(entry.fields);
        setPosts({
          ...entry,
          fields: resolvedFields
        });
        // console.log({ ...entry, fields: resolvedFields })
        setFaqs(resolvedFields.pageFaqItems.map(item => ({
          question: item.fields.faqTitle,
          answer: item.fields.faqDescription
        })));
      } catch (error) {
        console.error("Error fetching the post:", error);
      }
    };
    fetchPostById();
  }, []);
  // useEffect(() => {
  //   if (posts) {
  //     console.log('Home:', posts);
  //   }
  // }, [posts]);
  const settings1 = {
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 3000,
    adaptiveHeight: true,
    centerMode: true,
    variableWidth: true,
    arrows: false,
    swipeToSlide: true,
    touchThreshold: 10,
    responsive: [{
      breakpoint: 1124,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    }, {
      breakpoint: 650,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }]
  };
  const settings2 = {
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 3000,
    adaptiveHeight: true,
    centerMode: true,
    variableWidth: true,
    arrows: false,
    responsive: [{
      breakpoint: 1124,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    }, {
      breakpoint: 650,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }]
  };
  const settings3 = {
    infinite: false,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 3000,
    adaptiveHeight: false,
    centerMode: false,
    variableWidth: true,
    arrows: false,
    responsive: [{
      breakpoint: 1724,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    }, {
      breakpoint: 1624,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }]
  };
  const settings4 = {
    infinite: false,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 3000,
    adaptiveHeight: false,
    centerMode: false,
    variableWidth: true,
    arrows: false,
    responsive: [{
      breakpoint: 1724,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    }, {
      breakpoint: 1624,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }]
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "landing-page"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container-1",
    style: {
      backgroundImage: "url(".concat(posts === null || posts === void 0 || (_posts$fields4 = posts.fields) === null || _posts$fields4 === void 0 || (_posts$fields4 = _posts$fields4.cardBackgroundImage) === null || _posts$fields4 === void 0 || (_posts$fields4 = _posts$fields4.fields) === null || _posts$fields4 === void 0 || (_posts$fields4 = _posts$fields4.file) === null || _posts$fields4 === void 0 ? void 0 : _posts$fields4.url, ")"),
      height: "370px",
      borderRadius: "0 0 20px 20px",
      boxShadow: "0px 5px 20px 5px #101919",
      backgroundRepeat: "no-repeat",
      backgroundSize: "100% 100%"
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "heading"
  }, /*#__PURE__*/React.createElement("img", {
    className: "blr-pulse-logo",
    src: posts === null || posts === void 0 || (_posts$fields5 = posts.fields) === null || _posts$fields5 === void 0 || (_posts$fields5 = _posts$fields5.brandLogo) === null || _posts$fields5 === void 0 || (_posts$fields5 = _posts$fields5.fields) === null || _posts$fields5 === void 0 || (_posts$fields5 = _posts$fields5.file) === null || _posts$fields5 === void 0 ? void 0 : _posts$fields5.url,
    alt: ""
  }), /*#__PURE__*/React.createElement("p", {
    className: "heading-1"
  }, posts === null || posts === void 0 || (_posts$fields6 = posts.fields) === null || _posts$fields6 === void 0 ? void 0 : _posts$fields6.cardText1), /*#__PURE__*/React.createElement("p", {
    className: "heading-2"
  }, posts === null || posts === void 0 || (_posts$fields7 = posts.fields) === null || _posts$fields7 === void 0 ? void 0 : _posts$fields7.cardText2), skeletonLoading ? /*#__PURE__*/React.createElement("div", {
    className: "member-card",
    style: {
      backgroundImage: 'url("https://d3hc1c528irei0.cloudfront.net/ui/MembershipCards/AccountBannerSmall.png")',
      backgroundSize: "100%",
      height: "112px",
      width: "340px",
      margin: "28px 0"
    }
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      width: "310px",
      margin: "5px auto",
      justifyContent: "space-between"
    }
  }, /*#__PURE__*/React.createElement(Skeleton, {
    height: 25,
    width: 150,
    borderRadius: 10,
    count: 1,
    style: {
      opacity: "0.5"
    }
  }), /*#__PURE__*/React.createElement(Skeleton, {
    height: 25,
    width: 100,
    borderRadius: 10,
    count: 1,
    style: {
      opacity: "0.5"
    }
  })), /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      width: "310px",
      margin: "5px auto",
      justifyContent: "space-between"
    }
  }, /*#__PURE__*/React.createElement(Skeleton, {
    height: 25,
    width: 150,
    borderRadius: 10,
    count: 1,
    style: {
      opacity: "0.5"
    }
  }), /*#__PURE__*/React.createElement(Skeleton, {
    height: 25,
    width: 100,
    borderRadius: 10,
    count: 1,
    style: {
      opacity: "0.5"
    }
  })), /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      width: "310px",
      margin: "5px auto",
      justifyContent: "space-between"
    }
  }, /*#__PURE__*/React.createElement(Skeleton, {
    height: 25,
    width: 150,
    borderRadius: 10,
    count: 1,
    style: {
      opacity: "0.5"
    }
  }), /*#__PURE__*/React.createElement(Skeleton, {
    height: 25,
    width: 100,
    borderRadius: 10,
    count: 1,
    style: {
      opacity: "0.5"
    }
  })))) : /*#__PURE__*/React.createElement("div", {
    className: "member-card",
    style: {
      backgroundImage: 'url("https://d3hc1c528irei0.cloudfront.net/ui/MembershipCards/AccountBannerSmall.png")',
      backgroundSize: "100%",
      height: "112px",
      width: "340px",
      margin: "28px 0",
      color: "white"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      justifyContent: "space-between"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      color: "white",
      fontSize: "20px",
      fontStyle: "normal",
      fontWeight: "600",
      lineHeight: "120%",
      margin: "18px 18px 4px",
      flexDirection: "column",
      gap: "4px"
    }
  }, /*#__PURE__*/React.createElement("div", null, memberName ? memberName : ""), /*#__PURE__*/React.createElement("div", {
    style: {
      color: "#FFF",
      fontSize: "12px",
      fontWeight: "400",
      lineHeight: "120%"
    }
  }, /*#__PURE__*/React.createElement("div", null, tierCodes && memberData ? tierCodes.map(item => {
    if (item.tier_code === memberData.tier_data[0].tier_code_id) {
      return /*#__PURE__*/React.createElement("div", {
        key: item.id
      }, item.name);
    }
  }) : ""), /*#__PURE__*/React.createElement("div", null))), /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      gap: "4px",
      margin: "30px 18px 4px",
      fontWeight: "600"
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: "https://d3hc1c528irei0.cloudfront.net/ui/PulseCoin.png",
    alt: "",
    style: {
      margin: "0px",
      height: "22px"
    }
  }), memberData ? memberData.balances.length > 0 ? Math.round(memberData === null || memberData === void 0 || (_memberData$balances$ = memberData.balances[0]) === null || _memberData$balances$ === void 0 ? void 0 : _memberData$balances$.balance) : "0" : "0")), /*#__PURE__*/React.createElement("div", {
    style: {
      margin: "10px 18px 4px",
      display: "flex",
      fontSize: "12px",
      color: "#A9C4CF"
    }
  }, "Member Id:\xA0", /*#__PURE__*/React.createElement("div", {
    style: {
      fontWeight: "600",
      color: "white"
    }
  }, memberData ? memberData.member_id : ""))), /*#__PURE__*/React.createElement("a", {
    className: "view-reward-wallet",
    onClick: () => navigate("/transactions")
  }, posts === null || posts === void 0 || (_posts$fields8 = posts.fields) === null || _posts$fields8 === void 0 ? void 0 : _posts$fields8.cardCtaText, /*#__PURE__*/React.createElement("img", {
    className: "vector-right",
    src: "https://d3hc1c528irei0.cloudfront.net/ui/VectorRight.png",
    alt: ""
  })))), posts !== null && posts !== void 0 && (_posts$fields9 = posts.fields) !== null && _posts$fields9 !== void 0 && _posts$fields9.toggle9 ? /*#__PURE__*/React.createElement("div", {
    className: "CTA-coupon",
    style: {
      backgroundImage: "url(".concat(posts === null || posts === void 0 || (_posts$fields10 = posts.fields) === null || _posts$fields10 === void 0 || (_posts$fields10 = _posts$fields10.ctaCoupon[0]) === null || _posts$fields10 === void 0 || (_posts$fields10 = _posts$fields10.fields) === null || _posts$fields10 === void 0 || (_posts$fields10 = _posts$fields10.cardBackgroundImage) === null || _posts$fields10 === void 0 || (_posts$fields10 = _posts$fields10.fields) === null || _posts$fields10 === void 0 || (_posts$fields10 = _posts$fields10.file) === null || _posts$fields10 === void 0 ? void 0 : _posts$fields10.url, ")"),
      backgroundSize: "100%",
      margin: "35px auto",
      width: "335px",
      height: "166px",
      objectFit: "cover",
      backgroundRepeat: "no-repeat"
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "banner",
    dangerouslySetInnerHTML: {
      __html: pageTitleFunc(posts === null || posts === void 0 || (_posts$fields11 = posts.fields) === null || _posts$fields11 === void 0 || (_posts$fields11 = _posts$fields11.ctaCoupon[0]) === null || _posts$fields11 === void 0 || (_posts$fields11 = _posts$fields11.fields) === null || _posts$fields11 === void 0 ? void 0 : _posts$fields11.cardText1)
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "details"
  }, /*#__PURE__*/React.createElement(ReactMarkdown, {
    rehypePlugins: [rehypeRaw],
    remarkPlugins: [remarkGfm]
  }, posts === null || posts === void 0 || (_posts$fields12 = posts.fields) === null || _posts$fields12 === void 0 || (_posts$fields12 = _posts$fields12.ctaCoupon[0]) === null || _posts$fields12 === void 0 || (_posts$fields12 = _posts$fields12.fields) === null || _posts$fields12 === void 0 ? void 0 : _posts$fields12.cardText2)), /*#__PURE__*/React.createElement("button", {
    className: "invite"
  }, /*#__PURE__*/React.createElement("div", {
    onClick: () => navigate("/coupon")
  }, posts === null || posts === void 0 || (_posts$fields13 = posts.fields) === null || _posts$fields13 === void 0 || (_posts$fields13 = _posts$fields13.ctaCoupon[0]) === null || _posts$fields13 === void 0 || (_posts$fields13 = _posts$fields13.fields) === null || _posts$fields13 === void 0 ? void 0 : _posts$fields13.cardText3))) : /*#__PURE__*/React.createElement(React.Fragment, null), posts !== null && posts !== void 0 && (_posts$fields14 = posts.fields) !== null && _posts$fields14 !== void 0 && _posts$fields14.toggle10 ? /*#__PURE__*/React.createElement("div", {
    className: "CTA-raffle CTA-coupon",
    style: {
      backgroundImage: "url(".concat(posts === null || posts === void 0 || (_posts$fields15 = posts.fields) === null || _posts$fields15 === void 0 || (_posts$fields15 = _posts$fields15.ctaRaffle[0]) === null || _posts$fields15 === void 0 || (_posts$fields15 = _posts$fields15.fields) === null || _posts$fields15 === void 0 || (_posts$fields15 = _posts$fields15.cardBackgroundImage) === null || _posts$fields15 === void 0 || (_posts$fields15 = _posts$fields15.fields) === null || _posts$fields15 === void 0 || (_posts$fields15 = _posts$fields15.file) === null || _posts$fields15 === void 0 ? void 0 : _posts$fields15.url, ")"),
      backgroundSize: "100%",
      margin: "35px auto",
      width: "335px",
      height: "166px",
      objectFit: "cover",
      backgroundRepeat: "no-repeat"
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "banner",
    dangerouslySetInnerHTML: {
      __html: pageTitleFunc(posts === null || posts === void 0 || (_posts$fields16 = posts.fields) === null || _posts$fields16 === void 0 || (_posts$fields16 = _posts$fields16.ctaRaffle[0]) === null || _posts$fields16 === void 0 || (_posts$fields16 = _posts$fields16.fields) === null || _posts$fields16 === void 0 ? void 0 : _posts$fields16.cardText1)
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "details"
  }, /*#__PURE__*/React.createElement(ReactMarkdown, {
    rehypePlugins: [rehypeRaw],
    remarkPlugins: [remarkGfm]
  }, posts === null || posts === void 0 || (_posts$fields17 = posts.fields) === null || _posts$fields17 === void 0 || (_posts$fields17 = _posts$fields17.ctaRaffle[0]) === null || _posts$fields17 === void 0 || (_posts$fields17 = _posts$fields17.fields) === null || _posts$fields17 === void 0 ? void 0 : _posts$fields17.cardText2)), /*#__PURE__*/React.createElement("button", {
    className: "invite"
  }, /*#__PURE__*/React.createElement("div", {
    onClick: () => navigate("/raffle")
  }, posts === null || posts === void 0 || (_posts$fields18 = posts.fields) === null || _posts$fields18 === void 0 || (_posts$fields18 = _posts$fields18.ctaRaffle[0]) === null || _posts$fields18 === void 0 || (_posts$fields18 = _posts$fields18.fields) === null || _posts$fields18 === void 0 ? void 0 : _posts$fields18.cardText3))) : /*#__PURE__*/React.createElement(React.Fragment, null), posts !== null && posts !== void 0 && (_posts$fields19 = posts.fields) !== null && _posts$fields19 !== void 0 && _posts$fields19.toggle11 ? /*#__PURE__*/React.createElement("div", {
    className: "raffle-cta-container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "heading",
    dangerouslySetInnerHTML: {
      __html: pageTitleFunc(posts === null || posts === void 0 || (_posts$fields20 = posts.fields) === null || _posts$fields20 === void 0 ? void 0 : _posts$fields20.raffleTitle)
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "slider-container",
    style: {
      margin: "15px 0px 30px",
      overflow: "hidden",
      padding: "0 0 0 18px"
    }
  }, /*#__PURE__*/React.createElement(Slider, settings3, posts === null || posts === void 0 || (_posts$fields21 = posts.fields) === null || _posts$fields21 === void 0 || (_posts$fields21 = _posts$fields21.raffleContent) === null || _posts$fields21 === void 0 ? void 0 : _posts$fields21.map((item, index) => /*#__PURE__*/React.createElement("div", {
    key: index,
    className: "slide",
    style: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      height: "100%"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      color: "white",
      fontSize: "8px",
      width: "74px",
      height: "21px",
      backgroundColor: "#174F65",
      borderRadius: "25px",
      margin: "auto",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      position: "relative",
      top: "10px"
    }
  }, item.fields.cardText1), /*#__PURE__*/React.createElement("img", {
    style: {
      width: "161px",
      maxHeight: "100%",
      objectFit: "cover"
    },
    src: item.fields.cardBackgroundImage.fields.file.url,
    alt: item.fields.cardBackgroundImage.fields.file.filename
  }))))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("button", {
    className: "view-all"
  }, /*#__PURE__*/React.createElement("div", null, posts === null || posts === void 0 || (_posts$fields22 = posts.fields) === null || _posts$fields22 === void 0 ? void 0 : _posts$fields22.raffleButton)))) : /*#__PURE__*/React.createElement(React.Fragment, null), posts !== null && posts !== void 0 && (_posts$fields23 = posts.fields) !== null && _posts$fields23 !== void 0 && _posts$fields23.toggle12 ? /*#__PURE__*/React.createElement("div", {
    className: "earn-raffle-cta-container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "heading",
    dangerouslySetInnerHTML: {
      __html: pageTitleFunc(posts === null || posts === void 0 || (_posts$fields24 = posts.fields) === null || _posts$fields24 === void 0 ? void 0 : _posts$fields24.earnRafflesTitle)
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "slider-container",
    style: {
      margin: "15px 0px 30px",
      overflow: "hidden",
      padding: "0 0 0 18px"
    }
  }, /*#__PURE__*/React.createElement(Slider, settings4, posts === null || posts === void 0 || (_posts$fields25 = posts.fields) === null || _posts$fields25 === void 0 || (_posts$fields25 = _posts$fields25.earnRafflesContent) === null || _posts$fields25 === void 0 ? void 0 : _posts$fields25.map((item, index) => /*#__PURE__*/React.createElement("div", {
    key: index,
    className: "slide",
    style: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      height: "100%"
    }
  }, /*#__PURE__*/React.createElement("img", {
    style: {
      width: "224px",
      maxHeight: "100%",
      objectFit: "cover"
    },
    src: item.fields.cardBackgroundImage.fields.file.url,
    alt: item.fields.cardBackgroundImage.fields.file.filename
  })))))) : /*#__PURE__*/React.createElement(React.Fragment, null), posts !== null && posts !== void 0 && (_posts$fields26 = posts.fields) !== null && _posts$fields26 !== void 0 && _posts$fields26.toggle1 ? /*#__PURE__*/React.createElement("div", {
    className: "container-2"
  }, /*#__PURE__*/React.createElement("div", {
    className: "heading",
    dangerouslySetInnerHTML: {
      __html: pageTitleFunc(posts === null || posts === void 0 || (_posts$fields27 = posts.fields) === null || _posts$fields27 === void 0 ? void 0 : _posts$fields27.pageTitle1)
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "slider-container",
    style: {
      margin: "15px 0",
      overflow: "hidden"
    }
  }, /*#__PURE__*/React.createElement(Slider, settings2, posts === null || posts === void 0 || (_posts$fields28 = posts.fields) === null || _posts$fields28 === void 0 || (_posts$fields28 = _posts$fields28.pageContent1) === null || _posts$fields28 === void 0 ? void 0 : _posts$fields28.map((item, index) => /*#__PURE__*/React.createElement("div", {
    key: index,
    className: "slide",
    style: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      height: "100%"
    }
  }, /*#__PURE__*/React.createElement("img", {
    style: {
      width: "273px",
      maxHeight: "100%",
      objectFit: "cover"
    },
    src: item.fields.cardBackgroundImage.fields.file.url,
    alt: item.fields.cardBackgroundImage.fields.file.filename
  })))))) : /*#__PURE__*/React.createElement(React.Fragment, null), posts !== null && posts !== void 0 && (_posts$fields29 = posts.fields) !== null && _posts$fields29 !== void 0 && _posts$fields29.toggle2 ? /*#__PURE__*/React.createElement("div", {
    className: "container-3",
    style: {
      backgroundImage: "url(".concat(posts === null || posts === void 0 || (_posts$fields30 = posts.fields) === null || _posts$fields30 === void 0 || (_posts$fields30 = _posts$fields30.pageContent2[0]) === null || _posts$fields30 === void 0 || (_posts$fields30 = _posts$fields30.fields) === null || _posts$fields30 === void 0 || (_posts$fields30 = _posts$fields30.cardBackgroundImage) === null || _posts$fields30 === void 0 || (_posts$fields30 = _posts$fields30.fields) === null || _posts$fields30 === void 0 || (_posts$fields30 = _posts$fields30.file) === null || _posts$fields30 === void 0 ? void 0 : _posts$fields30.url, ")"),
      backgroundSize: "100%",
      height: "235px",
      margin: "5px 0 6px"
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "earn-points-container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "earn"
  }, posts === null || posts === void 0 || (_posts$fields31 = posts.fields) === null || _posts$fields31 === void 0 || (_posts$fields31 = _posts$fields31.pageContent2[0]) === null || _posts$fields31 === void 0 || (_posts$fields31 = _posts$fields31.fields) === null || _posts$fields31 === void 0 ? void 0 : _posts$fields31.cardText1), /*#__PURE__*/React.createElement("div", {
    className: "points-quantity"
  }, /*#__PURE__*/React.createElement(ReactMarkdown, {
    rehypePlugins: [rehypeRaw],
    remarkPlugins: [remarkGfm]
  }, posts === null || posts === void 0 || (_posts$fields32 = posts.fields) === null || _posts$fields32 === void 0 || (_posts$fields32 = _posts$fields32.pageContent2[0]) === null || _posts$fields32 === void 0 || (_posts$fields32 = _posts$fields32.fields) === null || _posts$fields32 === void 0 ? void 0 : _posts$fields32.cardText2)), /*#__PURE__*/React.createElement("div", {
    className: "transition"
  }, /*#__PURE__*/React.createElement("img", {
    className: "coin",
    src: "https://d3hc1c528irei0.cloudfront.net/ui/PulseCoin.png",
    alt: ""
  }), " ", posts === null || posts === void 0 || (_posts$fields33 = posts.fields) === null || _posts$fields33 === void 0 || (_posts$fields33 = _posts$fields33.pageContent2[0]) === null || _posts$fields33 === void 0 || (_posts$fields33 = _posts$fields33.fields) === null || _posts$fields33 === void 0 ? void 0 : _posts$fields33.cardText3))) : /*#__PURE__*/React.createElement(React.Fragment, null), posts !== null && posts !== void 0 && (_posts$fields34 = posts.fields) !== null && _posts$fields34 !== void 0 && _posts$fields34.toggle3 ? /*#__PURE__*/React.createElement("div", {
    className: "container-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "heading",
    dangerouslySetInnerHTML: {
      __html: pageTitleFunc(posts === null || posts === void 0 || (_posts$fields35 = posts.fields) === null || _posts$fields35 === void 0 ? void 0 : _posts$fields35.pageTitle3)
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "carousel-container"
  }, /*#__PURE__*/React.createElement(Carousel, {
    "data-bs-theme": "dark",
    controls: false,
    touch: true
  }, posts === null || posts === void 0 || (_posts$fields36 = posts.fields) === null || _posts$fields36 === void 0 || (_posts$fields36 = _posts$fields36.pageContent3) === null || _posts$fields36 === void 0 ? void 0 : _posts$fields36.map((item, index) => /*#__PURE__*/React.createElement(Carousel.Item, {
    key: index
  }, /*#__PURE__*/React.createElement("img", {
    className: "d-block w-100",
    src: item.fields.cardBackgroundImage.fields.file.url,
    alt: item.fields.cardBackgroundImage.fields.file.filename
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      position: "absolute",
      top: "72.56px",
      left: "0",
      width: "100%",
      height: "100%",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      color: "white"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      color: "#F1CB84",
      fontSize: "22px",
      fontWeight: "600",
      lineHeight: "normal"
    }
  }, item.fields.cardText1), /*#__PURE__*/React.createElement("div", {
    style: {
      color: "#FFF",
      fontSize: "13px",
      fontWeight: "400",
      lineHeight: "normal"
    }
  }, /*#__PURE__*/React.createElement(ReactMarkdown, {
    rehypePlugins: [rehypeRaw],
    remarkPlugins: [remarkGfm]
  }, item.fields.cardText2)), /*#__PURE__*/React.createElement("div", {
    style: {
      color: "#FFF",
      fontSize: "22px",
      fontWeight: "600",
      lineHeight: "normal",
      display: "flex",
      alignItems: "center"
    },
    dangerouslySetInnerHTML: {
      __html: cardTextZoomFunc(item.fields.cardText3)
    }
  }))))))) : /*#__PURE__*/React.createElement(React.Fragment, null), posts !== null && posts !== void 0 && (_posts$fields37 = posts.fields) !== null && _posts$fields37 !== void 0 && _posts$fields37.toggle4 ? /*#__PURE__*/React.createElement("div", {
    className: "container-5"
  }, /*#__PURE__*/React.createElement("div", {
    className: "heading",
    dangerouslySetInnerHTML: {
      __html: pageTitleFunc(posts === null || posts === void 0 || (_posts$fields38 = posts.fields) === null || _posts$fields38 === void 0 ? void 0 : _posts$fields38.pageTitle4)
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "carousel-container"
  }, /*#__PURE__*/React.createElement(Carousel, {
    "data-bs-theme": "dark",
    controls: false,
    touch: true
  }, posts === null || posts === void 0 || (_posts$fields39 = posts.fields) === null || _posts$fields39 === void 0 || (_posts$fields39 = _posts$fields39.pageContent4) === null || _posts$fields39 === void 0 ? void 0 : _posts$fields39.map((item, index) => /*#__PURE__*/React.createElement(Carousel.Item, {
    key: index
  }, /*#__PURE__*/React.createElement("img", {
    className: "d-block w-100",
    src: item.fields.cardBackgroundImage.fields.file.url,
    alt: item.fields.cardBackgroundImage.fields.file.filename
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      position: "absolute",
      top: "25px",
      left: "64px",
      width: "100%",
      height: "100%",
      color: "white"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      color: "#FFF",
      fontSize: "22px",
      fontWeight: "600",
      lineHeight: "normal"
    }
  }, item.fields.cardText1), /*#__PURE__*/React.createElement("div", {
    style: {
      color: "#FFF",
      fontSize: "14px",
      fontWeight: "400",
      lineHeight: "normal",
      width: "240.754px"
    }
  }, /*#__PURE__*/React.createElement(ReactMarkdown, {
    rehypePlugins: [rehypeRaw],
    remarkPlugins: [remarkGfm]
  }, item.fields.cardText2)), /*#__PURE__*/React.createElement("div", {
    className: "invite"
  }, /*#__PURE__*/React.createElement("button", null, item.fields.cardText3)))))))) : /*#__PURE__*/React.createElement(React.Fragment, null), posts !== null && posts !== void 0 && (_posts$fields40 = posts.fields) !== null && _posts$fields40 !== void 0 && _posts$fields40.toggle5 ? /*#__PURE__*/React.createElement("div", {
    className: "container-6"
  }, /*#__PURE__*/React.createElement("div", {
    className: "heading",
    dangerouslySetInnerHTML: {
      __html: pageTitleFunc(posts === null || posts === void 0 || (_posts$fields41 = posts.fields) === null || _posts$fields41 === void 0 ? void 0 : _posts$fields41.pageTitle5)
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "slider-container",
    style: {
      height: "380px",
      margin: "30px 0"
    }
  }, /*#__PURE__*/React.createElement(Slider, settings1, posts === null || posts === void 0 || (_posts$fields42 = posts.fields) === null || _posts$fields42 === void 0 || (_posts$fields42 = _posts$fields42.pageContent5) === null || _posts$fields42 === void 0 ? void 0 : _posts$fields42.map((item, index) => /*#__PURE__*/React.createElement("div", {
    key: index,
    className: "slide"
  }, /*#__PURE__*/React.createElement("img", {
    style: {
      textAlign: "center"
    },
    src: item.fields.cardBackgroundImage.fields.file.url,
    alt: item.fields.cardBackgroundImage.fields.file.filename
  })))))) : /*#__PURE__*/React.createElement(React.Fragment, null), posts !== null && posts !== void 0 && (_posts$fields43 = posts.fields) !== null && _posts$fields43 !== void 0 && _posts$fields43.toggle6 ? /*#__PURE__*/React.createElement("div", {
    className: "container-7",
    style: {
      backgroundImage: "url(".concat(posts === null || posts === void 0 || (_posts$fields44 = posts.fields) === null || _posts$fields44 === void 0 || (_posts$fields44 = _posts$fields44.pageContent6[0]) === null || _posts$fields44 === void 0 || (_posts$fields44 = _posts$fields44.fields) === null || _posts$fields44 === void 0 || (_posts$fields44 = _posts$fields44.cardBackgroundImage) === null || _posts$fields44 === void 0 || (_posts$fields44 = _posts$fields44.fields) === null || _posts$fields44 === void 0 || (_posts$fields44 = _posts$fields44.file) === null || _posts$fields44 === void 0 ? void 0 : _posts$fields44.url, ")"),
      backgroundSize: "100%",
      height: "255px",
      margin: "5px 0 0px"
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "refer-earn-container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "banner",
    dangerouslySetInnerHTML: {
      __html: pageTitleFunc(posts === null || posts === void 0 || (_posts$fields45 = posts.fields) === null || _posts$fields45 === void 0 || (_posts$fields45 = _posts$fields45.pageContent6[0]) === null || _posts$fields45 === void 0 || (_posts$fields45 = _posts$fields45.fields) === null || _posts$fields45 === void 0 ? void 0 : _posts$fields45.cardText1)
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "details"
  }, /*#__PURE__*/React.createElement(ReactMarkdown, {
    rehypePlugins: [rehypeRaw],
    remarkPlugins: [remarkGfm]
  }, posts === null || posts === void 0 || (_posts$fields46 = posts.fields) === null || _posts$fields46 === void 0 || (_posts$fields46 = _posts$fields46.pageContent6[0]) === null || _posts$fields46 === void 0 || (_posts$fields46 = _posts$fields46.fields) === null || _posts$fields46 === void 0 ? void 0 : _posts$fields46.cardText2)), /*#__PURE__*/React.createElement("div", {
    className: "invite"
  }, /*#__PURE__*/React.createElement("button", null, /*#__PURE__*/React.createElement("div", {
    onClick: () => navigate("/refer")
  }, posts === null || posts === void 0 || (_posts$fields47 = posts.fields) === null || _posts$fields47 === void 0 || (_posts$fields47 = _posts$fields47.pageContent6[0]) === null || _posts$fields47 === void 0 || (_posts$fields47 = _posts$fields47.fields) === null || _posts$fields47 === void 0 ? void 0 : _posts$fields47.cardText3))))) : /*#__PURE__*/React.createElement(React.Fragment, null), posts !== null && posts !== void 0 && (_posts$fields48 = posts.fields) !== null && _posts$fields48 !== void 0 && _posts$fields48.toggle7 ? /*#__PURE__*/React.createElement("div", {
    className: "container-8"
  }, /*#__PURE__*/React.createElement("div", {
    className: "heading",
    dangerouslySetInnerHTML: {
      __html: pageTitleFunc(posts === null || posts === void 0 || (_posts$fields49 = posts.fields) === null || _posts$fields49 === void 0 ? void 0 : _posts$fields49.pageTitle7)
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "carousel-container"
  }, /*#__PURE__*/React.createElement(Carousel, {
    "data-bs-theme": "dark",
    controls: false,
    touch: true
  }, posts === null || posts === void 0 || (_posts$fields50 = posts.fields) === null || _posts$fields50 === void 0 || (_posts$fields50 = _posts$fields50.pageContent7) === null || _posts$fields50 === void 0 ? void 0 : _posts$fields50.map((item, index) => /*#__PURE__*/React.createElement(Carousel.Item, {
    key: index
  }, /*#__PURE__*/React.createElement("img", {
    className: "d-block w-100",
    src: item.fields.cardBackgroundImage.fields.file.url,
    alt: item.fields.cardBackgroundImage.fields.file.filename
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      position: "absolute",
      top: "72.56px",
      left: "0",
      width: "100%",
      height: "100%",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      color: "white"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      color: "#F1CB84",
      fontSize: "22px",
      fontWeight: "600",
      lineHeight: "normal"
    }
  }, item.fields.cardText1), /*#__PURE__*/React.createElement("div", {
    style: {
      color: "#FFF",
      fontSize: "13px",
      fontWeight: "400",
      lineHeight: "normal"
    }
  }, /*#__PURE__*/React.createElement(ReactMarkdown, {
    rehypePlugins: [rehypeRaw],
    remarkPlugins: [remarkGfm]
  }, item.fields.cardText2)), /*#__PURE__*/React.createElement("div", {
    style: {
      color: "#FFF",
      fontSize: "22px",
      fontWeight: "600",
      lineHeight: "normal",
      display: "flex",
      alignItems: "center"
    },
    dangerouslySetInnerHTML: {
      __html: cardTextZoomFunc(item.fields.cardText3)
    }
  }))))))) : /*#__PURE__*/React.createElement(React.Fragment, null), posts !== null && posts !== void 0 && (_posts$fields51 = posts.fields) !== null && _posts$fields51 !== void 0 && _posts$fields51.toggle8 ? /*#__PURE__*/React.createElement("div", {
    className: "container-9"
  }, /*#__PURE__*/React.createElement("div", {
    className: "heading",
    dangerouslySetInnerHTML: {
      __html: pageTitleFunc(posts === null || posts === void 0 || (_posts$fields52 = posts.fields) === null || _posts$fields52 === void 0 ? void 0 : _posts$fields52.pageTitle8)
    }
  }), /*#__PURE__*/React.createElement("img", {
    className: "",
    src: posts === null || posts === void 0 || (_posts$fields53 = posts.fields) === null || _posts$fields53 === void 0 || (_posts$fields53 = _posts$fields53.pageContent8[0]) === null || _posts$fields53 === void 0 || (_posts$fields53 = _posts$fields53.fields) === null || _posts$fields53 === void 0 || (_posts$fields53 = _posts$fields53.cardBackgroundImage) === null || _posts$fields53 === void 0 || (_posts$fields53 = _posts$fields53.fields) === null || _posts$fields53 === void 0 || (_posts$fields53 = _posts$fields53.file) === null || _posts$fields53 === void 0 ? void 0 : _posts$fields53.url,
    alt: ""
  }), /*#__PURE__*/React.createElement("div", {
    className: "invite",
    style: {
      margin: "25px auto",
      justifyContent: "center",
      width: "117px"
    }
  }, /*#__PURE__*/React.createElement("button", {
    style: {
      width: "111px"
    }
  }, /*#__PURE__*/React.createElement("div", {
    onClick: () => navigate("/sponsorlist")
  }, "View All")))) : /*#__PURE__*/React.createElement("div", null), /*#__PURE__*/React.createElement(FAQList, {
    faqs: faqs,
    posts: posts,
    navigate: navigate
  }));
};
export { Home };